<div class="container-fluid mt-3">
  <div class="d-flex justify-content-between align-items-center mb-3">
    <h2>MOM with Kavita Sessions</h2>
    <button mat-raised-button color="primary" (click)="openAddDialog()"
            permission="Counselling MOM"
            [permissionTypes]="[PermissionType.ALL, PermissionType.ADD]">
      <mat-icon>add</mat-icon>
      Add New Session
    </button>
  </div>

  <!-- Search Filter -->
  <mat-form-field appearance="outline" class="w-100 mb-3">
    <mat-label>Search</mat-label>
    <input matInput (keyup)="applyFilter($event)" placeholder="Search sessions...">
    <mat-icon matSuffix>search</mat-icon>
  </mat-form-field>

  <!-- Loading Spinner -->
  <div *ngIf="isLoading" class="text-center py-5">
    <mat-spinner></mat-spinner>
  </div>

  <!-- Table -->
  <div class="mat-elevation-z8">
    <table mat-table [dataSource]="dataSource" matSort>

      <!-- Date Column -->
      <ng-container matColumnDef="date">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Date</th>
        <td mat-cell *matCellDef="let element">{{ formatDate(element.date) }}</td>
      </ng-container>

      <!-- Topic Column -->
      <ng-container matColumnDef="topic">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Topic</th>
        <td mat-cell *matCellDef="let element">{{ element.topic }}</td>
      </ng-container>

      <!-- Participants Column -->
      <ng-container matColumnDef="participants">
        <th mat-header-cell *matHeaderCellDef>Participants</th>
        <td mat-cell *matCellDef="let element">
          <span class="participants-text" [title]="getParticipantNames(element.participants)">
            {{ getParticipantNames(element.participants) | slice:0:50 }}
            {{ getParticipantNames(element.participants).length > 50 ? '...' : '' }}
          </span>
        </td>
      </ng-container>

      <!-- Remark Column -->
      <ng-container matColumnDef="remark">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Remarks</th>
        <td mat-cell *matCellDef="let element">{{element.remark}}

        </td>
      </ng-container>

      <!-- Actions Column -->
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>Actions</th>
        <td mat-cell *matCellDef="let element">
          <!-- VIEW -->
          <button
            permission="Counselling MOM"
            [permissionTypes]="[PermissionType.ALL, PermissionType.VIEW]"
            mat-icon-button
            color="accent"
            (click)="openViewDialog(element)"
            matTooltip="View">
            <mat-icon>visibility</mat-icon>
          </button>
          <button mat-icon-button color="primary" (click)="openEditDialog(element)" matTooltip="Edit"
                  permission="Counselling MOM"
                  [permissionTypes]="[PermissionType.ALL, PermissionType.EDIT]">
            <mat-icon>edit</mat-icon>
          </button>
          <button mat-icon-button color="warn" (click)="deleteSession(element)" matTooltip="Delete"
                  permission="Counselling MOM"
                  [permissionTypes]="[PermissionType.ALL, PermissionType.ARCHIVE]">
            <mat-icon>delete</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

      <!-- No Data Row -->
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell text-center py-5" [attr.colspan]="displayedColumns.length">
          No sessions found
        </td>
      </tr>
    </table>
    <ng-template #viewDialog>
      <h2 mat-dialog-title>MOM with Kavita – Session Details</h2>

      <mat-dialog-content class="mt-2">

        <!-- BASIC DETAILS -->
        <table class="table table-bordered table-sm w-100 mb-3">
          <tbody>
          <tr>
            <th style="width:30%">Date</th>
            <td>{{ getDate(selectedSession?.date) | date:'dd/MM/yyyy' }}</td>
          </tr>

          <tr>
            <th>Topic</th>
            <td>{{ selectedSession?.topic || '-' }}</td>
          </tr>

          <tr>
            <th>Status</th>
            <td>{{ selectedSession?.status || '-' }}</td>
          </tr>

          <tr>
            <th>Remark</th>
            <td>{{ selectedSession?.remark || '-' }}</td>
          </tr>

          <tr>
            <th>Participants</th>
            <td>
              <ul class="mb-0 ps-3">
                <li *ngFor="let p of selectedSession?.participants">
                  {{ p }}
                </li>
              </ul>
            </td>
          </tr>
          </tbody>
        </table>

        <!-- SESSION ITEMS -->
        <h6 class="fw-bold mb-2">Session Items</h6>

        <table
          class="table table-bordered table-sm w-100"
          *ngIf="selectedSession?.sessions?.length; else noSessions">
          <thead class="table-light">
          <tr>
            <th style="width:40%">Topic</th>
            <th style="width:60%">Remark</th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let s of selectedSession?.sessions">
            <td>{{ s.topic || '-' }}</td>
            <td>{{ s.remark || '-' }}</td>
          </tr>
          </tbody>
        </table>

        <ng-template #noSessions>
          <p class="text-muted fst-italic">No session items added</p>
        </ng-template>

        <!-- AUDIT DETAILS -->
        <table class="table table-bordered table-sm w-100 mt-3">
          <tbody>
          <tr>
            <th style="width:30%">Created By</th>
            <td>{{ selectedSession?.createdBy || '-' }}</td>
          </tr>

          <tr>
            <th>Created At</th>
            <td>{{ getDate(selectedSession?.createdAt) | date:'dd/MM/yyyy, hh:mm a' }}</td>
          </tr>

          <tr>
            <th>Updated At</th>
            <td>{{ getDate(selectedSession?.updatedAt) | date:'dd/MM/yyyy, hh:mm a' }}</td>
          </tr>
          </tbody>
        </table>

      </mat-dialog-content>

      <mat-dialog-actions align="end">
        <button mat-stroked-button color="primary" (click)="closeView()">
          Close
        </button>
      </mat-dialog-actions>
    </ng-template>


    <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]" showFirstLastButtons></mat-paginator>
  </div>
</div>
